/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { instanceOfFxIdApplicationPublicDataBuilderPublicDataBaseStatisticsOptionsDevToDevOptions, FxIdApplicationPublicDataBuilderPublicDataBaseStatisticsOptionsDevToDevOptionsFromJSONTyped, FxIdApplicationPublicDataBuilderPublicDataBaseStatisticsOptionsDevToDevOptionsToJSON, } from './FxIdApplicationPublicDataBuilderPublicDataBaseStatisticsOptionsDevToDevOptions';
export function FxIdApplicationPublicDataBuilderPublicDataBaseStatisticsOptionsDevToDevFromJSON(json) {
    return FxIdApplicationPublicDataBuilderPublicDataBaseStatisticsOptionsDevToDevFromJSONTyped(json, false);
}
export function FxIdApplicationPublicDataBuilderPublicDataBaseStatisticsOptionsDevToDevFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    if (instanceOfFxIdApplicationPublicDataBuilderPublicDataBaseStatisticsOptionsDevToDevOptions(json)) {
        return FxIdApplicationPublicDataBuilderPublicDataBaseStatisticsOptionsDevToDevOptionsFromJSONTyped(json, true);
    }
    return {};
}
export function FxIdApplicationPublicDataBuilderPublicDataBaseStatisticsOptionsDevToDevToJSON(json) {
    return FxIdApplicationPublicDataBuilderPublicDataBaseStatisticsOptionsDevToDevToJSONTyped(json, false);
}
export function FxIdApplicationPublicDataBuilderPublicDataBaseStatisticsOptionsDevToDevToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    if (instanceOfFxIdApplicationPublicDataBuilderPublicDataBaseStatisticsOptionsDevToDevOptions(value)) {
        return FxIdApplicationPublicDataBuilderPublicDataBaseStatisticsOptionsDevToDevOptionsToJSON(value);
    }
    return {};
}
//# sourceMappingURL=FxIdApplicationPublicDataBuilderPublicDataBaseStatisticsOptionsDevToDev.js.map